/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CredentialType } from './CredentialType';
import {
    CredentialTypeFromJSON,
    CredentialTypeFromJSONTyped,
    CredentialTypeToJSON,
} from './CredentialType';
import type { PublicKeyCredentialParams } from './PublicKeyCredentialParams';
import {
    PublicKeyCredentialParamsFromJSON,
    PublicKeyCredentialParamsFromJSONTyped,
    PublicKeyCredentialParamsToJSON,
} from './PublicKeyCredentialParams';

/**
 * 
 * @export
 * @interface ExportedPublicKeyCredential
 */
export interface ExportedPublicKeyCredential {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedPublicKeyCredential
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedPublicKeyCredential
     */
    last_used?: Date;
    /**
     * 
     * @type {CredentialType}
     * @memberof ExportedPublicKeyCredential
     */
    type: CredentialType;
    /**
     * 
     * @type {PublicKeyCredentialParams}
     * @memberof ExportedPublicKeyCredential
     */
    params: PublicKeyCredentialParams;
    /**
     * 
     * @type {string}
     * @memberof ExportedPublicKeyCredential
     */
    label?: string;
}

/**
 * Check if a given object implements the ExportedPublicKeyCredential interface.
 */
export function instanceOfExportedPublicKeyCredential(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "params" in value;

    return isInstance;
}

export function ExportedPublicKeyCredentialFromJSON(json: any): ExportedPublicKeyCredential {
    return ExportedPublicKeyCredentialFromJSONTyped(json, false);
}

export function ExportedPublicKeyCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedPublicKeyCredential {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': !exists(json, 'last_used') ? undefined : (new Date(json['last_used'])),
        'type': CredentialTypeFromJSON(json['type']),
        'params': PublicKeyCredentialParamsFromJSON(json['params']),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}

export function ExportedPublicKeyCredentialToJSON(value?: ExportedPublicKeyCredential | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'last_used': value.last_used === undefined ? undefined : (value.last_used.toISOString()),
        'type': CredentialTypeToJSON(value.type),
        'params': PublicKeyCredentialParamsToJSON(value.params),
        'label': value.label,
    };
}

